export enum AppRoutes {
  Login = '/auth/login',
  SignUp = '/auth/signup',
  ForgotPassword = '/auth/forgot-password',
  ResetPassword = '/auth/reset-password',
  Workouts = '/workouts',
  WorkoutsDetails = '/workouts-details',
  Profile = '/profile',
  BMICalculator = '/bmi-calculator',
  WorkoutsQuiz = '/workouts-quiz',
  Home = '/',
}

export enum UserImageSize {
  Small = 's',
  Medium = 'm',
  Large = 'l',
}
